import { BaseError } from './baseError';
export class UserError extends BaseError {
  constructor(e?: string) {
    super(e);
  }
}
